import { formatHtml } from '@/utils/format';

export default {
  namespaced: true,
  state: {
    spaceInfo: {},
    categoryInfo: [],
    docInfo: {},
  },
  mutations: {
    setDocData(state, { spaceInfo = {}, categoryInfo = [], docInfo = {} }) {
      state.spaceInfo = spaceInfo;
      state.categoryInfo = categoryInfo;
      Object.keys(docInfo).forEach((key) => {
        docInfo[key].html = formatHtml(docInfo[key].html);
      });
      state.docInfo = docInfo;
    },
  },
};
